if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
         this.form.querySelector("[name=id]").disabled = false;
 
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);        
        const sku = this.form.querySelector('[name="sku"]')?.value ?? null;
        const variant_id = this.form.querySelector('[name="id"]')?.value ?? null;
        const product_id = this.form.querySelector('[name="product-id"]')?.value ?? null;
        if (product_id == "gift_card") {
          //console.log("gift card");
        } else {
          try {
            const apiResponse = await fetch(
              "https://hook.us1.make.celonis.com/iqrl76crcce1l7qktaje9sow80ngmhly",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ sku }),
              }
            );

            const apiResponseData = await apiResponse.json();
            console.log('apiResponseData',apiResponseData);
            if (apiResponseData.type === "ConnectionError") {
              throw new Error(
                `API call failed with status ${apiResponse.message}`
              );
              return;
            }

            await new Promise((resolve) => setTimeout(resolve, 3000));

            if (apiResponseData <= 0) {
            //if (apiResponseData > 0) {
                setTimeout(() => {
                  var targetElement = document.querySelector('.product_id_'+product_id);
                  console.log('Attempting to find:', '.product_id_'+product_id);
                  if (targetElement) {
                      targetElement.click();
                      console.log('Element found:', '.product_id_'+product_id);
                  } else {
                      console.log('Element with class .product_id_'+product_id+' not found.');
                  }  
                }, 500);
                return;
            }
          } catch (error) {
            console.error("Error in external API call:", error);
            //alert("API Error: " + error.message);
            /*
            setTimeout(() => {
              var targetElement = document.querySelector('.product_id_'+product_id);
              console.log('Attempting to find:', '.product_id_'+product_id);
              if (targetElement) {
                  targetElement.click();
                  console.log('Element found:', '.product_id_'+product_id);
              } else {
                  console.log('Element with class .product_id_'+product_id+' not found.');
              }  
            }, 500);
            */
            this.submitButton.classList.remove("loading");
            this.querySelector(".loading__spinner").classList.add("hidden");
            this.submitButton.setAttribute("aria-disabled", false);
            return;
          }
        }

        // Continue with /cart/add process if stock is available
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        console.log(config.body,"config.body")
        fetch(`/cart/add.js`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('response',response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
            
            location.reload();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
